import { ActionFactoryParams } from '../../../../utils/ControlledComponent/ControlledComponent.types';
import { CalendarContext } from '../../../../utils/context/contextFactory';
import { WidgetElements } from '../../../../utils/bi/consts';
import { CalendarState } from '../../controller';
import { CloseDialogAction } from '../closeDialog/closeDialog';
import { mapDialogTypeToWidgetComponent } from '../../../../utils/bi/mappers';
import { bookingsCalendarClick } from '@wix/bi-logger-wixboost-ugc/v2';

export type DialogCloseElement =
  | WidgetElements.DIALOG_X_BUTTON
  | WidgetElements.DIALOG_CLOSE_BUTTON;

export type OnDialogClose = (clickedElement?: DialogCloseElement) => void;

export function createOnDialogCloseAction(
  {
    getControllerState,
    context: { biLogger, experiments },
  }: ActionFactoryParams<CalendarState, CalendarContext>,
  closeDialog: CloseDialogAction,
): OnDialogClose {
  return (clickedElement = WidgetElements.DIALOG_X_BUTTON) => {
    const [state] = getControllerState();
    const { dialog } = state;

    void biLogger.report(
      bookingsCalendarClick({
        component: mapDialogTypeToWidgetComponent(dialog?.type),
        element: clickedElement,
      }),
    );

    closeDialog();
  };
}
